import Vue from 'vue'
import store from "@/store/index.js"
import router from '@/router/index.js'
import i18n from '@/i18n.js'
import VueMeta from 'vue-meta'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUndo, faSort, faMinusCircle, faPlusCircle, faTh, faArrowRight, faPlayCircle, faChevronDown, faChevronLeft, faChevronRight, faCalendarAlt, faMapMarkerAlt, faTimes, faArrowCircleUp, faListOl, faSyncAlt} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = true

library.add( faUndo, faSort, faMinusCircle, faPlusCircle, faTh, faArrowRight, faPlayCircle, faChevronDown, faChevronLeft, faChevronRight, faCalendarAlt, faMapMarkerAlt, faTimes, faArrowCircleUp, faListOl, faSyncAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueMeta)

import App from '@/views/App.vue'
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// import WidgetTest from '@/widgets/WidgetTest.vue'
// new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(WidgetTest),
// }).$mount('#app')
